export default "/react/viborka-51666d79.png";